export default {
  /**
   * 分類と商品条件のTapirMkフォーマット
   */
  get() {
    return {
      /**
       * @see store.js
       */
      key: new Date().getTime().toString(),
      /**
       * 企業コード
       */
      company: undefined,
      /**
       * 実績なし商品を除外する
       */
      excludeNonActive: false,
      /**
       * 単品クラスターモードの際の選択モード
       *
       * 単品:item / 分類:category
       */
      selectMode: 'item',
      item: {
        /**
         * 選択分類（最下層）一覧
         */
        categories: [],
        /**
         * 選択商品一覧
         */
        items: [],
        /**
         * 入力エラー
         */
        errors: [],
      },
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する分類のフォーマットに変換する
   */
  mapToApiPayload(item) {
    const payload = {
      company: item.company,
      excludeNonActive: item.excludeNonActive,
      selectMode: item.selectMode,
    }

    // 単品でクラスターを行う際には商品指定か分類指定（常に最下層）がある
    if (item.selectMode === 'item') {
      payload.item = {
        company: item.company,
        items: item.item.items.map(i => i.code),
      }
    } else if (item.selectMode === 'category') {
      payload.item = {
        company: item.company,
        categories: item.item.categories,
      }
    }

    return payload
  },
  /**
   * applyToに対してtermを適用する
   */
  applyPayload(applyTo, item) {
    applyTo.key = new Date().getTime().toString()
    applyTo.company = item.company
    applyTo.excludeNonActive = item.excludeNonActive
    applyTo.selectMode = item.selectMode

    if (item.selectMode === 'item') {
      applyTo.item.company = item.company
      applyTo.item.items = item.item.items
    } else if (item.selectMode === 'category') {
      applyTo.item.company = item.company
      applyTo.item.categories = item.item.categories
    }
  },
}
